import { AppLayout } from '../components/AppLayout'
import { TenantList } from '../features/tenants/components/TenantList'

export function TenantsPage() {
  return (
    <AppLayout>
      <TenantList />
    </AppLayout>
  )
}
